import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { loginRequest } from "./authConfig";

export const Login = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const handleLoginEvent = async () => {
      try {
        if (!instance.getActiveAccount() && !sessionStorage.getItem("msal.interaction.status")) {
          await instance.loginRedirect(loginRequest);
        }
      } catch (error) {
        console.log("Login Error", error);
      }
    };

    handleLoginEvent();
  }, [instance]);
  return <></>;
};
